
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface CategoryStats {
  topic_count: number;
  post_count: number;
}

export const useCategoryStats = (categoryId: string) => {
  return useQuery({
    queryKey: ['category-stats', categoryId],
    queryFn: async () => {
      console.log('Fetching category statistics for:', categoryId);
      
      // Use direct queries instead of RPC
      const { data: category, error } = await supabase
        .from('categories')
        .select('topic_count, post_count')
        .eq('id', categoryId)
        .single();
      
      if (error) {
        console.error('Error fetching category stats:', error);
        throw error;
      }
      
      console.log('Category stats fetched:', category);
      return {
        topic_count: category?.topic_count || 0,
        post_count: category?.post_count || 0,
      } as CategoryStats;
    },
    enabled: !!categoryId,
  });
};
